import React, { useState, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import GallerySection from './GallerySection';
import api from '../services/api';
import './GalleryPage.css';

function GalleryPage() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/gallery')
      .then((res) => setImages(res.data || []))
      .catch(() => setImages([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="gallery-page">
      <Header />
      <main className="gallery-page-main">
        {loading ? (
          <p className="gallery-page-loading">Loading gallery...</p>
        ) : (
          <GallerySection images={images} />
        )}
      </main>
      <Footer />
    </div>
  );
}

export default GalleryPage;
